export const artificialIntelligenceData = {
  departmentName: "Department of Artificial Intelligence",
  bannerImage: "/infrastructure/ai/lab-1.JPG",
  
  about: {
    title: "About the Department",
    content: `The Department of Artificial Intelligence & Data Science at Rayalaseema University is dedicated to 
    advancing knowledge and skills in the cutting-edge fields of AI, machine learning, deep learning, and data science. 
    Our programs focus on developing intelligent systems, predictive analytics, big data technologies, and data-driven 
    decision making. We prepare students to become AI specialists and data scientists who can solve complex real-world 
    problems using advanced computational techniques.`,
    highlights: [
      "Specialized AI and data science laboratories with GPU computing facilities",
      "Focus on deep learning, natural language processing, and computer vision",
      "Industry collaborations for real-world project experience",
      "Research opportunities in advanced AI and big data analytics"
    ]
  },

  brochure: {
    title: "Department Brochure",
    pdfLink: "/artificialintelligence/department-brochure.pdf",
    description: "Download our comprehensive department brochure for detailed information about programs, facilities, and achievements."
  },

  hod: {
    id:'ai001',
    name: "V.SATISH KUMAR ",
    designation: "Co-ordinator & Assistant Professor(AD HOC) ",
    photo: "/artificialintelligence/sathis.JPG",
    email: "valmikisatish71@gmail.com ",
    mobile: "+91 9866248428 ",
    qualification: "B.Tech, M.Tech, Ph.D (Pursuing) ",
    specialization: "COMPUTER NETWORKS, ARTIFICIAL INTELLIGENCE, MACHINE LEARNING",
    message: `Welcome to the Department of Artificial Intelligence & Data Science. We are at the forefront of AI 
    education and research, preparing students to lead the AI revolution. Our curriculum is designed to provide 
    comprehensive knowledge of AI technologies while emphasizing practical applications and ethical considerations.`,
    profileLink: "/artificialintelligence/sathis.pdf"
  },

  bos: {
    title: "Board of Studies",
    members: [
      // {
      //   name: "Prof. Mahesh Kumar",
      //   designation: "Chairman",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Anitha Rani",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Dr. Prasad Kumar",
      //   designation: "Member",
      //   affiliation: "Rayalaseema University"
      // },
      // {
      //   name: "Prof. External Expert",
      //   designation: "External Member",
      //   affiliation: "AI Research Institute"
      // }
    ]
  },

  faculty: [
    {
      id:'ai001',
     name: "V.SATISH KUMAR ",
    designation: "Co-ordinator & Assistant Professor(AD HOC) ",
    photo: "/artificialintelligence/sathis.JPG",
    email: "valmikisatish71@gmail.com ",
    mobile: "+91 9866248428 ",
    qualification: "B.Tech, M.Tech, Ph.D (Pursuing) ",
    specialization: "COMPUTER NETWORKS, ARTIFICIAL INTELLIGENCE, MACHINE LEARNING",
     profileLink: "/artificialintelligence/sathis.pdf"
    },
    // {
    //   name: "Dr. Anitha Rani",
    //   designation: "Associate Professor",
    //   email: "anitha.rani@ruk.ac.in",
    //   mobile: "+91 98765 43263",
    //   photo: "/artificialintelligence/anitha-rani.jpg",
    //   qualification: "B.Tech., M.Tech., Ph.D.",
    //   specialization: "Natural Language Processing, Text Analytics",
    //   profileLink: "/artificialintelligence/ANITHA-RANI.pdf"
    // },
    // {
    //   name: "Dr. Prasad Kumar",
    //   designation: "Assistant Professor",
    //   email: "prasad.kumar@ruk.ac.in",
    //   mobile: "+91 98765 43264",
    //   photo: "/artificialintelligence/prasad-kumar.jpg",
    //   qualification: "B.Tech., M.Tech., Ph.D.",
    //   specialization: "Big Data Analytics, Machine Learning",
    //   profileLink: "/artificialintelligence/PRASAD-KUMAR.pdf"
    // }
  ],

  courses: {
    undergraduate: [
      {
        name: "B.Tech Artificial Intelligence & Data Science",
        duration: "4 Years",
        eligibility: "10+2 with Physics, Chemistry, and Mathematics",
        intake: "120 seats"
      }
    ],
    // postgraduate: [
    //   {
    //     name: "M.Tech Artificial Intelligence",
    //     duration: "2 Years",
    //     eligibility: "B.E./B.Tech in CSE/IT or related field",
    //     intake: "30 seats"
    //   },
    //   {
    //     name: "M.Tech Data Science",
    //     duration: "2 Years",
    //     eligibility: "B.E./B.Tech in CSE/IT or related field",
    //     intake: "30 seats"
    //   }
    // ],
    // research: [
    //   {
    //     name: "Ph.D. in Artificial Intelligence & Data Science",
    //     duration: "Minimum 3 Years",
    //     eligibility: "M.Tech with qualifying exam",
    //     areas: "Deep Learning, Machine Learning, Natural Language Processing, Computer Vision, Big Data, Predictive Analytics"
    //   }
    // ]
  },

  Infrastructure: [
    "/infrastructure/ai/class-1.JPG",
    "/infrastructure/ai/class-2.JPG",

    "/infrastructure/ai/lab-1.JPG",
    "/infrastructure/ai/lab-2.JPG",
    "/infrastructure/ai/lab-3.JPG",

  ]
};
